import PropTypes from "prop-types";
import DreamCastLogoIcon from "../assets/DreamCast_Logo_Icon.svg";
import styles from "./ControlsHeader.module.css";

/**
 * View component. Displays the DreamCast logo and page title on the left,
 * with optional custom controls on the right.
 */
export function ControlsHeader({ title, children }) {
  return (
    <div className={styles.container}>
      <div className={styles.titleGroup}>
        <img src={DreamCastLogoIcon} alt="" className={styles.logo} />
        <h2 className={styles.title}>{title ?? ""}</h2>
      </div>
      <div className={styles.controls}>{children}</div>
    </div>
  );
}

ControlsHeader.propTypes = {
  /**
   * The page title displayed next to the logo (e.g. "DreamCast - Audios")
   */
  title: PropTypes.string,

  /**
   * Optional controls rendered on the right side of the header
   */
  children: PropTypes.node,
};
